<template>
  <a-modal v-model="visible" :title="$t('数据库配置')" width="60%">
    <div slot="footer">
      <a-button type="default" :loading="loading" @click="handleConnection">{{ $t('测试连接') }}</a-button>
      <a-button type="default" :loading="loading" @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 3 }" :wrapperCol="{ span: 18 }">
      <a-form-model-item :label="$t('数据库类型')" prop="type">
        <a-select v-model="form.type" :options="typeOptions" />
      </a-form-model-item>
      <a-form-model-item :label="$t('主机')" prop="host">
        <a-input v-model="form.host" />
      </a-form-model-item>
      <a-form-model-item :label="$t('端口号')" prop="port">
        <a-input v-model="form.port" />
      </a-form-model-item>
      <a-form-model-item :label="$t('服务名')" prop="serviceName">
        <a-input v-model="form.serviceName" />
      </a-form-model-item>
      <a-form-model-item :label="$t('数据库')" prop="db">
        <a-input v-model="form.db" />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户名')" prop="userName">
        <a-input v-model="form.userName" />
      </a-form-model-item>
      <a-form-model-item :label="$t('密码')" prop="password">
        <a-input v-model="form.password" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { saveDb, testConnection } from '@/api/app/db'
import { sm4Encrypt } from '@/utils/sm4'
import md5 from 'js-md5'

export default {
data() {
  return {
    visible: false,
    form: {},
    app: {},
    loading: false
  }
},
computed: {
  rules() {
    const result = {
      type: [{ required: 'true', message: this.$t('请选择') }],
      host: [{ required: 'true', message: this.$t('请输入') }],
      port: [{ required: 'true', message: this.$t('请输入') }],
      db: [{ required: 'true', message: this.$t('请输入') }],
      userName: [{ required: 'true', message: this.$t('请输入') }],
    }
    if (this.form.type === 'oracle') {
      result.serviceName = [{ required: 'true', message: this.$t('请输入') }]
    }
    if (!this.form.id) {
      result.password = [{ required: 'true', message: this.$t('请输入') }]
    }
    return result
  },
  typeOptions() {
    return [ { label: 'mysql', value: 'mysql' }, { label: 'oracle', value: 'oracle' } ]
  },
},
methods: {
  show(app, db) {
    this.app = { ...app }
    this.form = { ...db }
    this.visible = true
  },
  getEncryptFormData(appId) {
    if (!appId || appId.length == 0) {
      return {}
    }
    const { host, port, serviceName, db, userName, password } = this.form
    const key = md5(appId).substr(8, 16)
    const iv = md5(key).substr(8, 16)
    return {
      host: sm4Encrypt(host, key, iv) || host,
      port: sm4Encrypt(port, key, iv) || port,
      serviceName: sm4Encrypt(serviceName, key, iv) || serviceName,
      db: sm4Encrypt(db, key, iv) || db,
      userName: sm4Encrypt(userName, key, iv) || userName,
      password: sm4Encrypt(password, key, iv) || password
    }
  },
  handleCommit() {
    this.$refs.form.validate((success, fields) => {
      if (!success) {
        return
      }
      const appId = this.form.appId || this.app.id
      const commitData = {
        ...this.form,
        ...this.getEncryptFormData(appId),
        appId
      }
      this.loading = true
      saveDb(commitData).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('保存成功'))
          this.$emit('ok', this.form)
          this.visible = false
        } else {
          this.$message.error(res.message || this.$t('保存失败'))
        }
      }).catch(err => {
        this.$message.error(this.$t('保存失败'))
      }).finally(() => {
        this.loading = false
      })
    })
  },
  handleConnection() {
    this.$refs.form.validate((success, fields) => {
      if (!success) {
        return
      }
      const appId = this.form.appId || this.app.id
      const commitData = {
        ...this.form,
        ...this.getEncryptFormData(appId),
        appId 
      }
      this.loading = true
      testConnection(commitData).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('连接成功'))
        } else {
          this.$message.error(res.message || this.$t('连接失败'))
        }
      }).catch(err => {
        this.$message.error(this.$t('连接失败'))
      }).finally(() => {
        this.loading = false
      })
    })
  }
}
}
</script>